// Actions for managing sales request restrictions in dealer office settings
import { apiGet, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "SETTINGS/RESTRICTIONS/SALES_REQUEST_RESTRICTIONS";

const ActionTypes = {
  GetSalesRequestRestrictions: `${NAMESPACE}/GET`,
  UpdateSalesRequestRestrictions: `${NAMESPACE}/UPDATE`,
};

export const getSalesRequestRestrictions = ({ settingsId }) =>
  apiGet(
    ActionTypes.GetSalesRequestRestrictions,
    `defaults-restrictions/${settingsId}/sales-request-restrictions`,
  );

export const updateSalesRequestRestrictions = (formData, { settingsId }) =>
  apiPut(
    ActionTypes.UpdateSalesRequestRestrictions,
    `defaults-restrictions/${settingsId}/sales-request-restrictions`,
    formData,
  );
